export default {
    name: 'QButton',
    props: {
        text: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: ''
        },
        status: {
            type: String,
            default: 'primary'
        },
        classes: {
            type: [String, Object],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        useLoadingSpinner: {
            type: Boolean,
            default: true
        },
        icon: {
            type: String,
            required: false
        }
    },
    computed: {
        isVisible() {
            return !!(this.loading && (this.text || this.icon));
        }
    }
};
